export default __webpack_public_path__ + "Revenue_Calculator_New_Product_Template_NA-ja-JP.374a0d28.xlsx";